import React, { useContext } from 'react';
import { IFrame as Iframe, TmoCard } from '@tmobile/tmo-bps-syncup-web-component-lib';

import config from '../../../configs/config';
import SyncUpProductContext from '../../../context/SyncUpProductContext';

const {
  iframeSubscriberPetsURL,
  iframeSubscriberTrackerURL,
  iframeSubscriberWatchURL
} = config.powerBiSettings;

function Subscriber() {
  const syncUpProductContext = useContext(SyncUpProductContext);
  const iframe = () => {
    switch (syncUpProductContext.syncUpAppName) {
      case 'TRACKER':
        return iframeSubscriberTrackerURL;
      case 'KIDSWATCH':
        return iframeSubscriberWatchURL;
      default:
        return iframeSubscriberPetsURL;
    }
  };

  return (
    <TmoCard>
      <Iframe src={iframe()} width="100%" height="836px" />
    </TmoCard>
  );
}

export default Subscriber;
